import { render, staticRenderFns } from "./StructureFinalStatusRequests.vue?vue&type=template&id=47bb6d70&"
import script from "./StructureFinalStatusRequests.vue?vue&type=script&lang=js&"
export * from "./StructureFinalStatusRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports